import { Controller } from "@hotwired/stimulus"

// Referred from `app/assets/javascripts/services.js`
export default class extends Controller {
  static targets = [
    'serviceField',
    'serviceOrderField',
    'startedAtField',
    'endedAtField',
    'customValueTypeField'
  ];

  connect() {
    if (this.hasServiceFieldTarget)      this.serviceDropdown = this.serviceFieldTarget.querySelector('select');
    if (this.hasStartedAtFieldTarget)    this.startedAtInput  = this.startedAtFieldTarget.querySelector('input');
    if (this.hasEndedAtFieldTarget)      this.endedAtInput    = this.endedAtFieldTarget.querySelector('input');
    if (this.hasServiceOrderFieldTarget) this.serviceOrderDropdown = this.serviceOrderFieldTarget.querySelector('select');
  }

  ///////////////
  /// Actions ///
  ///////////////

  serviceIdChanged(event) {
    const serviceId = event.target.value;

    this.#toggleStartedAt(serviceId);
    this.#toggleEndedAt(serviceId);
    this.#toggleServiceOrder(serviceId);
    this.#toggleCustomValueType(serviceId);
  }

  ///////////////
  /// Helpers ///
  ///////////////

  #toggleStartedAt(serviceId) {
    const requireStartedAt = serviceId && $(this.serviceDropdown).find('option:selected').data('require-started-at');

    this.startedAtFieldTarget.classList.toggle('hidden', !requireStartedAt);
    this.startedAtInput.toggleAttribute('required', !!requireStartedAt)
  }

  #toggleEndedAt(serviceId) {
    const requireEndedAt = serviceId && $(this.serviceDropdown).find('option:selected').data('require-ended-at');

    this.endedAtFieldTarget.classList.toggle('hidden', !requireEndedAt);
    this.endedAtInput.toggleAttribute('required', !!requireEndedAt)
  }

  #toggleCustomValueType(serviceId) {
    if (!this.hasCustomValueTypeFieldTarget) return;

    this.customValueTypeFieldTargets.forEach((customValueType) => {
      customValueType.classList.toggle(
        'hidden',
        serviceId !== customValueType.dataset.serviceId
      );
    });
  }

  #toggleServiceOrder(serviceId) {
    if (!this.hasServiceOrderFieldTarget) return;

    this.serviceOrderFieldTarget.classList.toggle('hidden', !serviceId)

    // Clear the service order options
    $(this.serviceOrderDropdown).empty();
    this.#updateServiceOrderSelect2Params(serviceId);
  }

  #updateServiceOrderSelect2Params(serviceId) {
    if (this.serviceOrderDropdown.length === 0) return;

    const formData = new FormData(this.element);
    const containerIDs = [];

    for(const [key, _] of formData.entries()) {
      if(key.startsWith("bulk_update[containers][")) {
        // Extract the container ID from the key
        const containerID = key.match(/\[(\d+)\]/)[1];
        containerIDs.push(containerID);
      }
    }

    // Setting the query params here.
    // Everytime reset the `container_id` to `containerIDs`
    const { container_id, ...existingParams } = $(this.serviceOrderDropdown).data('params') || {};
    const newParams = {
      ...existingParams,
      ...{
        custom_event_type_id: serviceId,
        container_id: containerIDs
      }
    };

    $(this.serviceOrderDropdown).attr('data-params', JSON.stringify(newParams));
  }
}
